import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnablePudoDeliveryOptions = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enablePudoDeliveryOptions);
};
